module.exports = __webpack_public_path__ + "assets/ad533a352046346d738a641940619756.mp3";